module.exports = __webpack_public_path__ + "static/media/CTLI_6-147w.c0a03b5b.png";